export default __webpack_public_path__ + "static/media/photoshopfront.1053280c.svg";